import Text from './text.vue';

export default Text;
